import { MovementMap } from "../../MovementMap";
import { TrackingHistory } from "../../asset/TrackingHistory";
import { MobileCommChat } from "../MobileCommChat";
import { Layout, Splitter, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommMessages extends Layout {
    layoutMobileCommChat: MobileCommChat;
    layoutMovementMap: MovementMap;
    layoutTrackingHistory: TrackingHistory;
    splitterTracking: Splitter;
    tabChat: Tab;
    tabTracking: Tab;
    tabsetMessages: Tabset;
}
